var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"generic-html",style:(_vm.customStyle)},[(_vm.html)?_c('div',{class:`html-${_vm.uuid}`,domProps:{"innerHTML":_vm._s(_vm.html)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }